import React, { useState, useEffect } from 'react';

const ChessGame = () => {
  const WIDTH = 8;
  const createEmptyBoard = () => Array.from({ length: WIDTH }, () => Array(WIDTH).fill(null));

  const [board, setBoard] = useState(createEmptyBoard());
  const [selectedPiece, setSelectedPiece] = useState(null);
  const [highlightedMoves, setHighlightedMoves] = useState([]);
  const [turn, setTurn] = useState('white');
  const [gameMode, setGameMode] = useState(null); // 'computer', 'player', 'assistant'
  const [gameStatus, setGameStatus] = useState('select');
  const [message, setMessage] = useState('Select game mode to start');
  const [aiThinking, setAiThinking] = useState(false);
  const [gameOver, setGameOver] = useState(false);

  const deepCopy = (arr) => JSON.parse(JSON.stringify(arr));

  // Function to create proper SVG pieces
  const createPieceSVG = (type, color) => {
    // We'll use Font Awesome style paths but with React SVG components
    const piecePaths = {
      king: "M224 0c17.7 0 32 14.3 32 32V48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v48H408c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400H80L3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40H192V112H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM38.6 473.4L80 432H368l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z",
      queen: "M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM134.1 143.8c3.3-13 15-23.8 30.2-23.8c12.3 0 22.6 7.2 27.7 17c12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17c15.3 0 27 10.8 30.2 23.8c7 27.8 32.2 48.3 62.1 48.3c10.8 0 21-2.7 29.8-7.4c8.4-4.4 18.9-4.5 27.6 .9c13 8 17.1 25 9.2 38L399.7 400H384 343.6 168.4 128 112.3L5.4 223.6c-7.9-13-3.8-30 9.2-38c8.7-5.3 19.2-5.3 27.6-.9c8.9 4.7 19 7.4 29.8 7.4c29.9 0 55.1-20.5 62.1-48.3zM256 224l0 0 0 0h0zM112 432H400l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H86.6C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z",
      bishop: "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V400H256V372.7c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32H128zM48 432L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512H297.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L272 432H48z",
      knight: "M96 48L82.7 61.3C70.7 73.3 64 89.5 64 106.5V238.9c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0c10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400H384l28.9-159c2.1-11.3 3.1-22.8 3.1-34.3V192C416 86 330 0 224 0H83.8C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H409.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432H64L22.6 473.4z",
      rook: "M32 192V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V192c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144H80L96 256 44.8 217.6C36.7 211.6 32 202.1 32 192zm176 96h32c8.8 0 16-7.2 16-16V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM22.6 473.4L64 432H384l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H38.6C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z",
      pawn: "M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88H96c-17.7 0-32 14.3-32 32c0 16.5 12.5 30 28.5 31.8L80 400H240L227.5 287.8c16-1.8 28.5-15.3 28.5-31.8c0-17.7-14.3-32-32-32h-8.5zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432H64L22.6 473.4z"
    };

    return (
      <div className={`piece ${color}`} data-piece={type}>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 448 512" 
          className={`w-full h-full ${color === 'white' ? 'text-white' : 'text-black'}`}
        >
          <path d={piecePaths[type]} fill="currentColor" />
        </svg>
      </div>
    );
  };

  const initializeBoard = () => {
    const newBoard = createEmptyBoard();
    const backRowSetup = ['rook', 'knight', 'bishop', 'queen', 'king', 'bishop', 'knight', 'rook'];
    
    // Set up pawns
    for (let i = 0; i < WIDTH; i++) {
      newBoard[1][i] = { type: 'pawn', color: 'black', hasMoved: false };
      newBoard[6][i] = { type: 'pawn', color: 'white', hasMoved: false };
    }
    
    // Set up back rows
    for (let i = 0; i < WIDTH; i++) {
      newBoard[0][i] = { type: backRowSetup[i], color: 'black', hasMoved: false };
      newBoard[7][i] = { type: backRowSetup[i], color: 'white', hasMoved: false };
    }
    
    return newBoard;
  };

  useEffect(() => {
    setBoard(initializeBoard());
  }, []);


  useEffect(() => {
    setBoard(initializeBoard());
  }, []);

  const startGame = (mode) => {
    setGameMode(mode);
    setGameStatus('active');
    setBoard(initializeBoard());
    setSelectedPiece(null);
    setHighlightedMoves([]);
    setTurn('white');
    setMessage("Game started! White's turn");
    setGameOver(false);
  };

  // Check if a move is valid based on chess rules
  const isValidMove = (fromRow, fromCol, toRow, toCol) => {
    const piece = board[fromRow][fromCol];
    if (!piece || piece.color !== turn) return false;
    
    const targetPiece = board[toRow][toCol];
    if (targetPiece && targetPiece.color === piece.color) return false;
    
    const rowDiff = Math.abs(toRow - fromRow);
    const colDiff = Math.abs(toCol - fromCol);
    
    // Check if there are pieces in the path (except for knight)
    if (piece.type !== 'knight' && !isPathClear(fromRow, fromCol, toRow, toCol)) {
      return false;
    }
    
    // Movement rules for each piece type
    switch (piece.type) {
      case 'pawn':
        // Pawns move differently based on color
        const direction = piece.color === 'white' ? -1 : 1;
        
        // Regular move (1 square forward)
        if (fromCol === toCol && toRow === fromRow + direction && !targetPiece) {
          return true;
        }
        
        // Initial 2-square move
        if (
          fromCol === toCol && 
          toRow === fromRow + 2 * direction && 
          !piece.hasMoved && 
          !targetPiece && 
          !board[fromRow + direction][fromCol]
        ) {
          return true;
        }
        
        // Capture move (diagonal)
        if (
          Math.abs(fromCol - toCol) === 1 && 
          toRow === fromRow + direction && 
          targetPiece
        ) {
          return true;
        }
        
        return false;
      
      case 'knight':
        // Knights move in an L-shape: 2 squares in one direction and 1 square perpendicular
        return (rowDiff === 2 && colDiff === 1) || (rowDiff === 1 && colDiff === 2);
      
      case 'bishop':
        // Bishops move diagonally
        return rowDiff === colDiff;
      
      case 'rook':
        // Rooks move horizontally or vertically
        return fromRow === toRow || fromCol === toCol;
      
      case 'queen':
        // Queens move like a rook or bishop
        return fromRow === toRow || fromCol === toCol || rowDiff === colDiff;
      
      case 'king':
        // Kings move one square in any direction
        return rowDiff <= 1 && colDiff <= 1;
      
      default:
        return false;
    }
  };

  // Check if the path between two squares is clear
  const isPathClear = (fromRow, fromCol, toRow, toCol) => {
    const rowDiff = toRow - fromRow;
    const colDiff = toCol - fromCol;
    
    // Determine direction of movement
    const rowDir = rowDiff === 0 ? 0 : rowDiff > 0 ? 1 : -1;
    const colDir = colDiff === 0 ? 0 : colDiff > 0 ? 1 : -1;
    
    let currRow = fromRow + rowDir;
    let currCol = fromCol + colDir;
    
    // Check each square in the path
    while (currRow !== toRow || currCol !== toCol) {
      if (board[currRow][currCol] !== null) {
        return false; // Path is blocked
      }
      currRow += rowDir;
      currCol += colDir;
    }
    
    return true; // Path is clear
  };

  const movePiece = (fromRow, fromCol, toRow, toCol) => {
    const newBoard = deepCopy(board);
    const movingPiece = { ...newBoard[fromRow][fromCol], hasMoved: true };
    
    // Handle capturing
    if (newBoard[toRow][toCol] !== null) {
      // Check for game end (king capture)
      if (newBoard[toRow][toCol].type === 'king') {
        setGameOver(true);
        setMessage(`${turn.charAt(0).toUpperCase() + turn.slice(1)} wins! Game over.`);
      }
    }
    
    // Move the piece
    newBoard[toRow][toCol] = movingPiece;
    newBoard[fromRow][fromCol] = null;
    
    return newBoard;
  };

  const handleSquareClick = (row, col) => {
    if (aiThinking || gameOver || gameStatus !== 'active') return;
    
    if (selectedPiece) {
      const [fromRow, fromCol] = selectedPiece;
      
      // If clicking the same square, deselect
      if (fromRow === row && fromCol === col) {
        setSelectedPiece(null);
        setHighlightedMoves([]);
        return;
      }
      
      // Try to move the piece
      if (isValidMove(fromRow, fromCol, row, col)) {
        const newBoard = movePiece(fromRow, fromCol, row, col);
        setBoard(newBoard);
        setSelectedPiece(null);
        setHighlightedMoves([]);
        
        if (!gameOver) {
          setTurn(turn === 'white' ? 'black' : 'white');
          setMessage(`${turn === 'white' ? 'Black' : 'White'}'s turn`);
        }
      }
    } else {
      // Select a piece
      if (board[row][col] && board[row][col].color === turn) {
        setSelectedPiece([row, col]);
        
        // Find all possible moves
        let possibleMoves = [];
        for (let r = 0; r < WIDTH; r++) {
          for (let c = 0; c < WIDTH; c++) {
            if (isValidMove(row, col, r, c)) {
              possibleMoves.push([r, c]);
            }
          }
        }
        
        setHighlightedMoves(possibleMoves);
      }
    }
  };

  // Render piece with proper SVG
  const renderPiece = (piece) => {
    if (!piece) {
      // Render an empty square
      return <div className="empty-square"></div>;
    }
    return createPieceSVG(piece.type, piece.color);
  };
  
  return (
    <div className="w-full max-w-md mx-auto mt-8 bg-white rounded-lg shadow-md p-4">
      <div className="text-2xl font-bold mb-4 text-center">Chess</div>
      
      {gameStatus === 'select' ? (
        <div className="flex flex-col gap-4 mb-4">
          <button 
            className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600" 
            onClick={() => startGame('player')}
          >
            Play with Another Player
          </button>
          <button 
            className="bg-green-500 text-white p-2 rounded hover:bg-green-600" 
            onClick={() => startGame('computer')}
          >
            Play with Computer
          </button>
          <button 
            className="bg-yellow-500 text-white p-2 rounded hover:bg-yellow-600" 
            onClick={() => startGame('assistant')}
          >
            Assistant Mode
          </button>
        </div>
      ) : (
        <div className="text-center mb-4">
          <div className="text-lg font-semibold flex items-center justify-center gap-2">
            <div className={`w-4 h-4 rounded-full ${turn === 'white' ? 'bg-white border border-gray-400' : 'bg-black'}`}></div>
            {message} 
            {aiThinking && <span>(Computer is thinking...)</span>}
          </div>
        </div>
      )}
      
      <div className="grid grid-cols-8 border-2 border-gray-800 aspect-square">
        {board.map((row, rowIndex) => (
          row.map((piece, colIndex) => (
            <div 
              key={`${rowIndex}-${colIndex}`}
              className={`w-full h-full flex items-center justify-center relative
                ${(rowIndex + colIndex) % 2 === 0 ? 'bg-amber-200' : 'bg-amber-800'}
                ${selectedPiece && selectedPiece[0] === rowIndex && selectedPiece[1] === colIndex ? 'bg-blue-300' : ''}
                ${highlightedMoves.some(([r, c]) => r === rowIndex && c === colIndex) ? 'bg-green-400' : ''}
                cursor-pointer hover:opacity-90 transition-colors`}
              onClick={() => handleSquareClick(rowIndex, colIndex)}
            >
              <div className="w-full h-full flex items-center justify-center">
                {renderPiece(piece)}
              </div>
              
              {/* Square coordinates (for debugging) */}
              <div className="absolute bottom-0 right-0 text-xs opacity-50">
                {String.fromCharCode(97 + colIndex)}{8 - rowIndex}
              </div>
            </div>
          ))
        ))}
      </div>
      
      {gameStatus !== 'select' && (
        <div className="mt-4 flex justify-between">
          <button 
            className="bg-red-500 text-white p-2 rounded hover:bg-red-600" 
            onClick={() => setGameStatus('select')}
          >
            New Game
          </button>
          
          {gameMode === 'assistant' && (
            <button 
              className="bg-purple-500 text-white p-2 rounded hover:bg-purple-600"
              onClick={() => {
                // Implement hint or suggestion functionality
                alert("Hint feature coming soon!");
              }}
            >
              Get Hint
            </button>
          )}
        </div>
      )}
      
      {/* Add some styles for the chess pieces */}
      <style jsx>{`
  .piece {
    width: 80%;
    height: 80%;
    position: relative;
  }
  .piece.white svg {
    filter: drop-shadow(1px 1px 1px rgba(0,0,0,0.5));
  }
  .piece.black svg {
    filter: drop-shadow(1px 1px 1px rgba(255,255,255,0.5));
  }
  .empty-square {
    width: 100%;
    height: 100%;
  }
`}</style>
    </div>
  );
};

export default ChessGame;